module.exports = __webpack_public_path__ + "img/bottom.40c9b2ed.png";